import React from "react";
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody } from 'mdbreact';
import { Button } from 'antd';
import '../card.css';
import axios from 'axios';
import "react-notifications-component/dist/theme.css";
import Select from "react-select";
import i18n from '../i18n';
import {connect} from 'react-redux';
import {reactLocalStorage} from 'reactjs-localstorage';
import Menutest from './menu.js';

import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import ReactPhoneInput from 'react-phone-input-2';
import { API_BASE_URL } from "../utils/endpoints";


var groupOptions = []

  class AddContact extends React.Component {

    constructor(props) {
       super(props);
       this.state = {
         mobile: '',
         firstname: '',
         secondname: '',
         familyname: '',
         job: '',
         company: '',
         groupselect:'',
         group_id:'',
         selectedValues:[],
         options_sender:[],
         options_senders:[],
         custom_filter1:'',
         custom_filter2:'',
         custom_filter3:'',
         custom_filter4:'',
         custom_filter5:'',
         custom_filter6:'',
         area: '',
        country: '',
        district:'',
        governerate:''
       }
     
     }

     handleChangearea = event =>
     {
           this.setState({ area: event.target.value});
     }
     handleChangecountry = event =>
     {
           this.setState({ country: event.target.value});
     }
     handleChangedistrict = event =>
     {
           this.setState({ district: event.target.value});
     }
     handleChangegovernerate = event =>
     {
           this.setState({ governerate: event.target.value});
     }
   
     handleChangecustom_filter1 = event =>
     {
           this.setState({ custom_filter1: event.target.value});
     }
     handleChangecustom_filter2 = event =>
{
      this.setState({ custom_filter2: event.target.value});
}
handleChangecustom_filter3 = event =>
{
      this.setState({ custom_filter3: event.target.value});
}
handleChangecustom_filter4 = event =>
{
      this.setState({ custom_filter4: event.target.value});
}
handleChangecustom_filter5 = event =>
{
      this.setState({ custom_filter5: event.target.value});
}
handleChangecustom_filter6 = event =>
{
      this.setState({ custom_filter6: event.target.value});
}

     onChangegroup= event =>{
      console.log(event)
   /* const newArray = this.state.options_senders;
    var i;
    for(i=0;i<event.length;i++)
      {
        if(newArray.includes(event[i].value) === false){
          newArray.push({
            group_id:event[i].value,
            group_name:event[i].label
          });
              }
            }*/
  this.setState({selectedValues: event}, function () {
  });
  
}




    componentDidMount(){
      var lang=i18n.language;
      if(lang ==="ar")
      {
        document.querySelector('.title_cate').style = 'text-align:right;';       
    
      
      }
      
 

        
      }





handleChange=(value)=> {
  this.setState({ mobile: value })
  console.log(this.state.mobile)
}

handleChangefisrtname =event =>
{
  
  this.setState({ firstname: event.target.value});
  if(event.target.value.length >15){
    toast({
      type: 'warning',
      title:i18n.t('warning.label'),
      description: i18n.t('Max_length_of_input_15_characters.label'),
      animation: 'bounce',
      time: 5000,
     
  });
  }
}

handleChangesecondname = event =>
{
      this.setState({ secondname: event.target.value});
      if(event.target.value.length >15){
        toast({
          type:'warning',
          title: i18n.t('warning.label'),
          description: i18n.t('Max_length_of_input_15_characters.label'),
          animation: 'bounce',
          time: 5000,
         
      });

}
}
handleChangefamilyname = event =>
{
      this.setState({ familyname: event.target.value});
      if(event.target.value.length >15){
        toast({
          type: 'warning',
          title: i18n.t('warning.label'),
          description: i18n.t('Max_length_of_input_15_characters.label'),
          animation: 'bounce',
          time: 5000,
         
      });

}
}
handleChangejob = event =>
{
      this.setState({ job: event.target.value});

}
handleChangecompany = event =>
{
      this.setState({ company: event.target.value});

}




handleSubmit = event =>
{

  if(this.state.firstname.length >15 || this.state.secondname.length >15 || this.state.familyname.length >15){
    toast({
      type: 'warning',
      title: i18n.t('warning.label'),
      description: i18n.t('Max_length_of_input_15_characters.label'),
      animation: 'bounce',
      time: 5000,
     
  });

}
else{
  var newarrayGroups=[]
  var i;
  for(i=0;i<this.state.selectedValues.length;i++)
    {
      newarrayGroups.push({
        group_id:this.state.selectedValues[i].value,
        group_name:this.state.selectedValues[i].label,
      })
    }
      event.preventDefault();
      var x=this;
      var token=reactLocalStorage.get('accessToken');
      const user = [{
        'mobile_number': this.state.mobile,
        'first_name': this.state.firstname,
        'second_name':this.state.secondname,
        'family_name':this.state.familyname,
        'job':this.state.job,
        'company':this.state.company,
        'groups':newarrayGroups,
        'custom_filter1':this.state.custom_filter1,
        'custom_filter2':this.state.custom_filter2,
        'custom_filter3':this.state.custom_filter3,
        'custom_filter4':this.state.custom_filter4,
        'custom_filter5':this.state.custom_filter5,
        'custom_filter6':this.state.custom_filter6,
        'area': this.state.area,
        'country': this.state.country,
        'district':this.state.district,
        'governerate':this.state.governerate
      }];
      var data=user;
      var ip=API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if(ip.includes(s2))
      {
        apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/"+reactLocalStorage.get('user_id_login')+"/insertContacts";
      }
      else
      {
       apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/"+reactLocalStorage.get('user_id_login')+"/insertContacts";
      }
      var headers = {
       'Content-Type': 'application/json',
       'token' :token
        }
      axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
      {
      if(response.data.status === 'success' && response.data.result.failed_insert  != 1)
      {
       
       window.location="contact";


      }
     if(response.data.result.failed_insert == 1){
        toast({
          type: 'warning',
          title:i18n.t('warning.label'),
          description: i18n.t('duplicate_contact.label'),
          animation: 'bounce',
          time: 5000,
         
      });
  


      }
    
      })
      .catch(function (error) {
      console.log(error);
      toast({
        type: 'error',
        title: i18n.t('error.label'),
        description:i18n.t('Something_wrong.label'),
        animation: 'bounce',
        time: 5000,

    });
      });
    }
    }
componentWillMount(){
  var token=reactLocalStorage.get('accessToken');
  var ip=API_BASE_URL;
  var s2 = "localhost:3000";
  var apiBaseUrl;
  if(ip.includes(s2))
  {
   apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/getGroups";     
  }
  else
  {
   apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/getGroups";
  }


  var headers = {'Content-Type': 'application/json', 'token' :token }
axios.get(apiBaseUrl,{headers: headers})
   .then(res => {

     if(res.data != undefined)
       {
         const dataoption=res.data.result.groups;
         var length=res.data.result.groups.length;
         var i;
         const newArr = this.state.options_sender;
         for(i=0;i<length;i++)
         {
          var value_option=dataoption[i].group_name;

          newArr.push({
             label: value_option, 
             value:dataoption[i].id
         });
           
         }
         groupOptions= newArr;
         this.setState({mobile:this.state.mobile})
      }
    })
}
    back=()=>
    {
      window.location="contact";
    }



  render() {
  return (
    <div className="big_div">
          <Menutest/>
          <div className="actionMenu">
    <div className="add_form">
    <MDBContainer>
      <MDBRow>
        <MDBCol md="6">
          <MDBCard className="add_card">
            <MDBCardBody>
              <form onSubmit={this.handleSubmit} className="title_cate">
                <p className="h4 text-center py-4 text_style darked_color">{i18n.t('Add_Contact.label')}</p>
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                  style={{color:'black'}}
                >
                 
                  {i18n.t('Mobile_Number.label')}
                </label>
           
                <ReactPhoneInput required="required" onlyCountries={["jo"]} defaultCountry={'jo'} onChange={this.handleChange} value={this.state.mobile}  excludeCountries={["il"]}/>

                <br />
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                  style={{color:'black'}}
                >
                  
                  {i18n.t('First_Name.label')}
                </label>
                <input
                  type="text"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="firstname"
                  onChange={this.handleChangefisrtname}
                />
              <br/>

              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{color:'black'}}
              >
                
                {i18n.t('Second_Name.label')}
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="secondname"
                onChange={this.handleChangesecondname}
              />
             <br/>
              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{color:'black'}}
              >
                
                {i18n.t('Family_Name.label')}
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="familyname"
                onChange={this.handleChangefamilyname}
              />
  <br/>
              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{color:'black'}}
              >
                
                {i18n.t('Job.label')}
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="job"
                onChange={this.handleChangejob}
              />
                <br/>
              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{color:'black'}}
              >
              {i18n.t('Company.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="company"
                onChange={this.handleChangecompany}
              />
             <br/>
             
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{color:'black'}}
              >
              {i18n.t('custom_filter1.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="option1"
                onChange={this.handleChangecustom_filter1}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{color:'black'}}
              >
              {i18n.t('custom_filter2.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="option2"
                onChange={this.handleChangecustom_filter2}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{color:'black'}}
              >
              {i18n.t('custom_filter3.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="option3"
                onChange={this.handleChangecustom_filter3}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{color:'black'}}
              >
              {i18n.t('custom_filter4.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="option4"
                onChange={this.handleChangecustom_filter4}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{color:'black'}}
              >
              {i18n.t('custom_filter5.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="option5"
                onChange={this.handleChangecustom_filter5}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{color:'black'}}
              >
              {i18n.t('custom_filter6.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="option6"
                onChange={this.handleChangecustom_filter6}
              />
             <br/>

             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{color:'black'}}
              >
              {i18n.t('area.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="area"
                onChange={this.handleChangearea}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{color:'black'}}
              >
              {i18n.t('country.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="country"
                onChange={this.handleChangecountry}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{color:'black'}}
              >
              {i18n.t('district.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="district"
                onChange={this.handleChangedistrict}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{color:'black'}}
              >
              {i18n.t('governerate.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="governerate"
                onChange={this.handleChangegovernerate}
              />
             <br/>

             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{color:'black'}}
              >
              {i18n.t('Groups.label')}
                
              </label>
               <Select
                                  placeholder='Select ...'
                                  fluid
                                  isMulti
                                  search
                                  selection
                                  options={groupOptions}
                                  onChange={this.onChangegroup.bind(this)}
                                />
                         <br />

                         <SemanticToastContainer />
                  <div className="text-center py-4 mt-3">
                  <Button className="submit_btn_darked">

                    <MDBBtn color="cyan"  onClick={this.back}>
                     
                     {i18n.t('Back.label')}
                    </MDBBtn>
                    </Button>

                  <Button className="submit_btn_darked">
                    <MDBBtn color="cyan" type="submit">
                    {i18n.t('Submit.label')}
                    </MDBBtn>
                    </Button>

                  </div>
              </form>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    </div>   </div>   </div>
  );
}
};
const mapStateToProps = (state)=>{
  return {...state}
}
export default connect(mapStateToProps) (AddContact);
